/**
 * @deprecated Will be removed
 */
export enum StoreNames {
    GENESIS_UI = 'genesis-ui',
    GENESIS_ADMIN = 'genesis-admin',
    GENESIS_CLIENT_ADMIN = 'genesis-client-admin-ui'
}
